module.exports = __webpack_public_path__ + "img/mtc.3fcbac23.svg";